import { useEffect, useState } from 'react';
import './thinking.css';

const STAGES: Array<[number, string]> = [
  [0, 'Смотрю базу знаний'],
  [2500, 'Готовлю ответ'],
  [9000, 'Ещё немного'],
];

/**
 * «Ассистент думает»: вращающаяся искра и переливающийся текст, подпись меняется
 * по времени (что делает модель, мы не знаем — показываем, что работа идёт).
 */
export function Thinking() {
  const [stage, setStage] = useState(0);
  useEffect(() => {
    const timers = STAGES.slice(1).map(([ms], i) => window.setTimeout(() => setStage(i + 1), ms));
    return () => timers.forEach((t) => window.clearTimeout(t));
  }, []);

  return (
    <div className="th-wrap" role="status" aria-live="polite">
      <svg className="th-spark" viewBox="0 0 24 24" aria-hidden="true">
        {Array.from({ length: 8 }, (_, i) => (
          <rect
            key={i}
            x="11"
            y="2"
            width="2"
            height="8"
            rx="1"
            transform={`rotate(${i * 45} 12 12)`}
          />
        ))}
      </svg>
      <span className="th-text" key={stage}>
        {STAGES[stage][1]}…
      </span>
    </div>
  );
}
